<div class="form-group">
  <label for="fieldOption.label" class="form-label">
    {{ fieldOption.name }}
    <span *ngIf="fieldOption.validator[0].required">*</span>
  </label>
  <div *ngIf="fieldOption.form_type != 'user_form'">
    <p-inputNumber
      [style]="{ width: '100%' }"
      [(ngModel)]="valueOfData"
      [inputId]="fieldOption.label"
      mode="decimal"
      [useGrouping]="false"
      [maxFractionDigits]="fieldOption.validator[0].decimal_places"
      [required]="fieldOption.validator[0].required"
      [placeholder]="fieldOption.place_holder"
      [disabled]="fieldOption.disabled"
      [max]="fieldOption.validator[0].max"
      [min]="fieldOption.validator[0].min"
      [name]="fieldOption.name"
      (ngModelChange)="onInputChange()"
      (change)="onInputChange()"
      autocomplete="off"
    >
    </p-inputNumber>
  </div>
  <div *ngIf="fieldOption.form_type === 'user_form'">
    <div class="input-wrapper">
      <p-inputNumber
        [style]="{ width: '100%' }"
        [(ngModel)]="valueOfData"
        [inputId]="fieldOption.label"
        mode="decimal"
        [useGrouping]="false"
        [maxFractionDigits]="fieldOption.validator[0].decimal_places"
        [required]="fieldOption.validator[0].required"
        [disabled]="fieldOption.disabled"
        [max]="fieldOption.validator[0].max"
        [min]="fieldOption.validator[0].min"
        [name]="fieldOption.name"
        (ngModelChange)="onInputChange()"
        (change)="onInputChange()"
        autocomplete="off"
      >
      </p-inputNumber>
      <button 
        pButton pRipple type="button" icon="icon-edit" class="edit-icon"
        (click)="onEdit(fieldOption.model)"
        *ngIf="fieldOption?.disabled && fieldOption?.kyc_status === 'P' && !fieldOption.isEditing">
      </button>
      <button 
        pButton pRipple type="button" label="Save" class="edit-icon"
        (click)="onSave(fieldOption.model)" [disabled]="(requiredError || requiredMin || requiredMax)"
        *ngIf="(fieldOption.isEditing && fieldOption?.kyc_status === 'P')">
      </button>
    </div>
  </div>
  <span class="text-danger" *ngIf="requiredError"
    >{{ fieldOption.name }} is required</span
  >
  <span class="text-danger" *ngIf="requiredMin"
    >{{ fieldOption.name }} can have min. value of
    {{ fieldOption.validator[0].min }}</span
  >
  <span class="text-danger" *ngIf="requiredMax"
    >{{ fieldOption.name }} can have max. value of
    {{ fieldOption.validator[0].max }}</span
  >
</div>
